import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VehicleLayout from '../../components/VehicleLayout';
import { useAxios } from '../../utils/hook/useAxios';
import './mc-PriceAndReduction.css';

/* Champ numérique avec suffixe (€ ou %) et recommandation */
function RateField({ id, label, value, onChange, unit = '%', placeholder = 'Ex : 10', reco }) {
  return (
    <div className="mc-field">
      <label className="mc-field-label" htmlFor={id}>
        {label}
      </label>
      <div className="mc-input-affix">
        <input
          id={id}
          type="text"
          inputMode="decimal"
          className="mc-input"
          name={id}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <span>{unit}</span>
      </div>
      {reco && <p className="mc-field-hint">Recommandation : {reco}</p>}
    </div>
  );
}

function PriceAndReduction() {
  const axios = useAxios();
  const [voitures, setVoitures] = useState([]);
  const userData = JSON.parse(window.localStorage.getItem('me'));
  const { vehiculeId, mois } = useParams();
  const [PrixParJour, setPrixParJour] = useState(0);
  const [Discount3days, setDiscount3days] = useState(0);
  const [Discount7days, setDiscount7days] = useState(0);
  const [Discount2weeks, setDiscount2weeks] = useState(0);
  const [Discount30days, setDiscount30days] = useState(0);
  const [Discount2months, setDiscount2months] = useState(0);
  const [DiscountInstantany, setDiscountInstantany] = useState(0);
  const [DiscountBefore7days, setDiscountBefore7days] = useState(0);

  const [Discounts, setDiscounts] = useState([]);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get('/availabilities/getbyvehiculeid/' + vehiculeId);

        if (response.data) {
          setPrixParJour(response.data[0].Default_price);
        }

        const resp = await axios.get('/discounts/getbyvehiculeid/' + vehiculeId);

        if (resp.data) {
          setDiscounts(resp.data);
          setDiscount3days(getReductionPercentage(resp.data, '0'));
          setDiscount7days(getReductionPercentage(resp.data, '1'));
          setDiscount2weeks(getReductionPercentage(resp.data, '2'));
          setDiscount30days(getReductionPercentage(resp.data, '3'));
          setDiscount2months(getReductionPercentage(resp.data, '4'));
          setDiscountInstantany(getReductionPercentage(resp.data, '5'));
          setDiscountBefore7days(getReductionPercentage(resp.data, '6'));
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  function getReductionPercentage(data, reservationDuration) {
    for (const item of data) {
      if (item.reservation_duration === reservationDuration) {
        return item.pourcentage_reduction;
      }
    }
    return null; // Return null if no matching reservation duration is found
  }
  function Enregistrer() {
    console.log(PrixParJour);
    let fetchReviews = async () => {
      try {
        const response = await axios.put(
          '/availabilities/updatePrincingbyDefaultVehicule/' + vehiculeId,
          {
            vehiculeId: vehiculeId,
            Default_price: PrixParJour,
          }
        );

        if (response.data) {
          toast.success('Prix ajouté pour votre véhicule');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '0',
          pourcentage_reduction: Discount3days,
        });

        if (response.data) {
          toast.success('Réduction pour plus de 3 jours ajouté pour votre véhicule');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '1',
          pourcentage_reduction: Discount7days,
        });

        if (response.data) {
          toast.success('Réduction pour plus de 7 jours ajouté pour votre véhicule');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '2',
          pourcentage_reduction: Discount2weeks,
        });

        if (response.data) {
          toast.success('Réduction pour plus de 2 semaines ajouté pour votre véhicule');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '3',
          pourcentage_reduction: Discount30days,
        });

        if (response.data) {
          toast.success('Réduction pour plus de 30 jours ajouté pour votre véhicule');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '4',
          pourcentage_reduction: Discount2months,
        });

        if (response.data) {
          toast.success('Réduction pour plus de 2 mois ajouté pour votre véhicule');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '5',
          pourcentage_reduction: DiscountInstantany,
        });

        if (response.data) {
          toast.success('Réduction pour une reservation instantanée a été ajouté');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }

      try {
        const response = await axios.put('/discounts/updateOrCreateDiscounts/' + vehiculeId, {
          vehiculeId: vehiculeId,
          reservation_duration: '6',
          pourcentage_reduction: DiscountBefore7days,
        });

        if (response.data) {
          toast.success('Réduction pour une reservation au moins 7 jours avant a été ajouté');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }

  // Réductions par durée (même ordre / mêmes états que dans Enregistrer)
  const durationDiscounts = [
    {
      id: 'discount3days',
      label: 'Réduction pour 3 jours ou plus',
      value: Discount3days,
      set: setDiscount3days,
      reco: '10 %',
    },
    {
      id: 'discount7days',
      label: 'Réduction pour 7 jours ou plus',
      value: Discount7days,
      set: setDiscount7days,
      reco: '10 %',
    },
    {
      id: 'discount2weeks',
      label: 'Réduction pour deux semaines',
      value: Discount2weeks,
      set: setDiscount2weeks,
      reco: '25 %',
    },
    {
      id: 'discount30days',
      label: 'Réduction pour 30 jours ou plus',
      value: Discount30days,
      set: setDiscount30days,
      reco: '30 %',
    },
    {
      id: 'discount2months',
      label: 'Réduction pour deux mois',
      value: Discount2months,
      set: setDiscount2months,
      reco: '40 %',
    },
  ];

  return (
    <VehicleLayout vehicleId={vehiculeId} pageTitle="Prix et réductions">
      <ToastContainer />

      <div className="mc-stack">
        <header className="mc-page-head">
          <h1 className="mc-account-title">Prix et réductions</h1>
          <p className="mc-form-subtitle">
            Fixez votre prix par jour et encouragez les réservations plus longues ou anticipées.
          </p>
        </header>

        {/* ===================== PRIX ===================== */}
        <section className="mc-form-card">
          <h2 className="mc-form-title mc-form-title--md">Prix</h2>
          <p className="mc-form-subtitle">Gérez vos paramètres de prix.</p>

          <button
            type="button"
            className="mc-link-btn"
            data-bs-toggle="modal"
            data-bs-target="#commentGagnerArgent"
          >
            Comment vais-je gagner ?
          </button>

          <div
            className="modal fade mc-modal"
            id="commentGagnerArgent"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="commentGagnerArgentLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h2 className="modal-title mc-modal-title" id="commentGagnerArgentLabel">
                    Revenus
                  </h2>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Fermer"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mc-modal-text">
                    <p>
                      Avec vos paramètres de prix actuels, vous recevez 85 % du prix du voyage,
                      incluant toute réduction applicable. La différence sert à protéger votre
                      véhicule et à couvrir les frais d’exploitation de la plateforme Moovicar,
                      notamment pour la vérification des invités et l’accès 24 h/24, 7 j/7 à notre
                      Service Clients.
                    </p>
                    <p>
                      <strong>Exemple</strong>
                    </p>
                    <p>Votre prix journalier moyen pour les sept prochains jours est de 25 €.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mc-form-block">
            <h3 className="mc-form-section-title">Prix par jour</h3>
            <p className="mc-form-subtitle">
              Définissez votre prix journalier par défaut. Vous pourrez toujours personnaliser le
              prix pour certains jours sur votre calendrier. Les prix ne tiennent pas compte des
              réductions applicables.
            </p>

            <div className="mc-form-alert mc-form-alert--info" role="note">
              <i className="bi bi-info-circle"></i>
              <span>
                Nous collectons encore des données pour améliorer les recommandations de prix pour
                votre région.
              </span>
            </div>

            <RateField
              id="prixParJour"
              label="Prix par jour"
              unit="€"
              placeholder="Prix par jour"
              value={PrixParJour}
              onChange={setPrixParJour}
              reco="31 €"
            />
          </div>

          <div className="mc-form-block">
            <h3 className="mc-form-section-title">Prix personnalisé</h3>
            <p className="mc-form-subtitle">
              Affichez vos prix sur le calendrier et définissez un prix spécifique pour certaines
              journées.
            </p>
            <Link
              className="mc-btn mc-btn--secondary mc-btn--sm mc-inline-btn"
              to={'/account/voiture/' + vehiculeId + '/calendar/0'}
            >
              <i className="bi bi-calendar3"></i>
              Gérer les prix sur le calendrier
            </Link>
          </div>

          <div className="mc-form-block">
            <h3 className="mc-form-section-title">Majoration de dernière minute</h3>
            <p className="mc-form-subtitle">
              Maximisez vos gains sur les voyages de dernière minute en majorant automatiquement vos
              prix pour les réservations effectuées le jour même. Assurez-vous que le préavis dans
              vos préférences de réservation permet les réservations le jour même.
            </p>
            <button type="button" className="mc-link-btn">
              Fonctionnement de la majoration tarifiaire
            </button>

            <RateField
              id="majorationInstantanee"
              label="Majoration pour réservation le jour même"
              value={DiscountInstantany}
              onChange={setDiscountInstantany}
              reco="5 %"
            />
          </div>
        </section>

        {/* ===================== RÉDUCTIONS ===================== */}
        <section className="mc-form-card">
          <h2 className="mc-form-title mc-form-title--md">Réductions</h2>
          <p className="mc-form-subtitle">
            Fixez des réductions personnalisées pour inciter les invités à planifier à l’avance et à
            réserver des voyages plus longs.
          </p>
          <button type="button" className="mc-link-btn">
            Fonctionnement des réductions
          </button>

          <div className="mc-form-block">
            <h3 className="mc-form-section-title">Tarif dégressif</h3>
            <p className="mc-form-subtitle">
              Incitez les invités à réserver votre voiture pour de plus longues périodes en offrant
              des réductions pour les voyages d’une fin de semaine, d’une semaine ou d’un mois.
            </p>

            <div className="mc-grid-2">
              {durationDiscounts.map(({ id, label, value, set, reco }) => (
                <RateField
                  key={id}
                  id={id}
                  label={label}
                  value={value}
                  onChange={set}
                  reco={reco}
                />
              ))}
            </div>
          </div>

          <div className="mc-form-block">
            <h3 className="mc-form-section-title">Réduction pour la réservation anticipée</h3>
            <p className="mc-form-subtitle">
              Incitez les invités à réserver à l’avance en offrant une réduction pour la réservation
              anticipée.
            </p>

            <div className="mc-grid-2">
              <RateField
                id="discountBefore7days"
                label="Au moins 7 jours à l’avance"
                value={DiscountBefore7days}
                onChange={setDiscountBefore7days}
                reco="5 %"
              />
            </div>
          </div>
        </section>

        {/* ===================== ENREGISTRER ===================== */}
        <div className="mc-savebar">
          <span className="mc-savebar-text">Pensez à enregistrer vos modifications.</span>
          <button type="button" className="mc-btn mc-btn--primary" onClick={Enregistrer}>
            Enregistrer
            <i className="bi bi-check2"></i>
          </button>
        </div>
      </div>
    </VehicleLayout>
  );
}

export default PriceAndReduction;
